import React, { useState, useEffect, useRef } from 'react';
import Logo from '../components/Logo';
import api from '../api';
import useResponsive from '../hooks/useResponsive';

const HASAR_LBL  = { kasko:'🛡️ Kasko', trafik:'🚗 Trafik', nakit:'💵 Nakit' };
const DURUM_RENK = { beklemede:'#e67e22', onarimda:'#2980b9', kapatldi:'#95a5a6', tamamlandi:'#27ae60' };

function Toast({ msg }) {
  return (
    <div style={{ position:'fixed', bottom:24, right:20, background:'var(--ink)', color:'white',
      padding:'11px 18px', borderRadius:4, fontFamily:"'Barlow Condensed',sans-serif",
      fontSize:13, fontWeight:700, opacity:msg?1:0, transform:msg?'translateY(0)':'translateY(8px)',
      transition:'all .25s', zIndex:9999, pointerEvents:'none' }}>
      {msg}
    </div>
  );
}

function Modal({ children, onKapat, baslik, renk }) {
  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.5)', zIndex:300,
      display:'flex', alignItems:'center', justifyContent:'center', padding:16 }}
      onClick={onKapat}>
      <div style={{ background:'var(--surface)', borderRadius:6, width:'100%', maxWidth:460,
        overflow:'hidden', boxShadow:'0 20px 60px rgba(0,0,0,.2)' }}
        onClick={e => e.stopPropagation()}>
        <div style={{ padding:'16px 20px', display:'flex', alignItems:'center',
          justifyContent:'space-between', borderBottom:'1px solid var(--border)',
          borderTop:`4px solid ${renk||'var(--ink)'}` }}>
          <span style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:17, fontWeight:900,
            textTransform:'uppercase', letterSpacing:.5 }}>{baslik}</span>
          <button onClick={onKapat} style={{ background:'none', border:'none',
            fontSize:20, cursor:'pointer', color:'var(--muted)', padding:4 }}>✕</button>
        </div>
        <div style={{ padding:20 }}>{children}</div>
      </div>
    </div>
  );
}

const navBtn = () => ({
  background:'rgba(255,255,255,.08)', border:'1px solid rgba(255,255,255,.15)',
  color:'rgba(255,255,255,.8)', padding:'6px 12px', borderRadius:3, cursor:'pointer',
  fontFamily:"'Barlow Condensed',sans-serif", fontSize:11, fontWeight:700,
  letterSpacing:1, textTransform:'uppercase',
});

export default function Muhasebe({ kullanici, onGeriDon, onAracAc, canGor, canDuzenle }) {
  const { isMobile } = useResponsive();
  const gor = canGor || (() => true);
  const duzenle = canDuzenle || (() => true);
  const [araclar,     setAraclar]     = useState([]);
  const [yukleniyor,  setYukleniyor]  = useState(true);
  const [muhSekme,    setMuhSekme]    = useState('bekliyor');
  const [fatNoMod,    setFatNoMod]    = useState(null);
  const [fatGuncelleMod, setFatGuncelleMod] = useState(null);
  const [iptalMod,    setIptalMod]    = useState(null);
  const [fatNoVal,    setFatNoVal]    = useState('');
  const [fatGuncelVal, setFatGuncelVal] = useState('');
  const [arama,       setArama]       = useState('');
  const [toastMsg,    setToastMsg]    = useState('');
  const toastTimer = useRef();

  const toast = msg => {
    setToastMsg(msg);
    clearTimeout(toastTimer.current);
    toastTimer.current = setTimeout(() => setToastMsg(''), 2600);
  };

  useEffect(() => {
    yukle();
  }, []);

  const yukle = async () => {
    setYukleniyor(true);
    try {
      const { data } = await api.get('/araclar/muhasebe');
      setAraclar(data);
    } catch {
      toast('Araçlar yüklenemedi');
    }
    setYukleniyor(false);
  };

  // Tüm araçlar - lokasyon filtresi yok
  const faturaBekliyor = araclar.filter(a => !a.fatura_durum || a.fatura_durum === 'bekliyor');
  const faturaKesildi  = araclar.filter(a => a.fatura_durum === 'kesildi');
  const faturaIptal    = araclar.filter(a => a.fatura_durum === 'iptal');

  const sekmeListe = muhSekme === 'bekliyor' ? faturaBekliyor
                   : muhSekme === 'kesildi'  ? faturaKesildi
                   : faturaIptal;

  const filtreli = sekmeListe.filter(a =>
    !arama || a.plaka?.toLowerCase().includes(arama.toLowerCase()) ||
    a.firma_adi?.toLowerCase().includes(arama.toLowerCase())
  );

  const faturaKes = async () => {
    if (!fatNoVal.trim()) { toast('Fatura numarası girin'); return; }
    try {
      await api.put(`/araclar/${fatNoMod.id}/fatura`, { fatura_no: fatNoVal });
      toast('✅ Fatura kesildi');
      setFatNoMod(null); setFatNoVal('');
      yukle();
    } catch (e) { toast('Hata: ' + (e.response?.data?.hata || e.message)); }
  };

  const faturaIptalEt = async () => {
    try {
      await api.put(`/araclar/${iptalMod.id}/fatura`, { fatura_durum:'iptal' });
      toast('Fatura iptal edildi');
      setIptalMod(null);
      yukle();
    } catch (e) { toast('Hata: ' + (e.response?.data?.hata || e.message)); }
  };

  const faturaNoGuncelle = async () => {
    if (!fatGuncelVal.trim()) { toast('Fatura numarası girin'); return; }
    try {
      await api.put(`/araclar/${fatGuncelleMod.id}/fatura-no`, { fatura_no: fatGuncelVal });
      toast('✅ Fatura numarası güncellendi');
      setFatGuncelleMod(null); setFatGuncelVal('');
      yukle();
    } catch (e) { toast('Hata: ' + (e.response?.data?.hata || e.message)); }
  };

  const AracKart = ({ a }) => {
    let ekspOzet = null;
    try { ekspOzet = a.ekspetriz_ozet ? JSON.parse(a.ekspetriz_ozet) : null; } catch {}
    const token = localStorage.getItem('otoflow_token') || '';
    const vitrinUrl = a.id && token
      ? `${api.defaults.baseURL?.replace('/api','')}/api/araclar/${a.id}/ilk-foto/raw?token=${encodeURIComponent(token)}`
      : null;
    const [vitrinHata, setVitrinHata] = React.useState(false);

    return (
      <div style={{ background:'var(--surface)', border:'1px solid var(--border2)', borderRadius:6, overflow:'hidden' }}>
        <div style={{ display:'flex', gap:16, padding:'16px 20px', flexDirection:isMobile ? 'column' : 'row' }}>
          {/* Vitrin foto */}
          <div style={{ width:80, height:80, borderRadius:4, overflow:'hidden', flexShrink:0, background:'var(--surface2)', border:'1px solid var(--border2)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:24 }}>
            {vitrinUrl && !vitrinHata
              ? <img src={vitrinUrl} alt="" style={{ width:'100%', height:'100%', objectFit:'cover' }} onError={() => setVitrinHata(true)} />
              : '🚛'
            }
          </div>
          {/* Bilgiler */}
          <div style={{ flex:1, minWidth:0 }}>
            <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:6, flexWrap:'wrap' }}>
              <span style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:22, fontWeight:900, color:'var(--accent)' }}>{a.plaka}</span>
              <span style={{ fontSize:11, padding:'2px 6px', borderRadius:2, background:'#f0ede8', color:'var(--ink2)' }}>{HASAR_LBL[a.hasar_turu]}</span>
              <span style={{ fontSize:11, color:'var(--muted)' }}>{a.lokasyon === 'ikitelli' ? 'İkitelli' : 'Hadımköy'}</span>
            </div>
            <div style={{ display:'grid', gridTemplateColumns:isMobile ? '1fr' : '1fr 1fr', gap:'6px 16px', fontSize:12, marginBottom:8 }}>
              <div><span style={{ color:'var(--muted)' }}>Marka:</span> <strong>{a.marka} {a.model}</strong></div>
              <div><span style={{ color:'var(--muted)' }}>Şasi No:</span> <strong>{a.sasi_no || '—'}</strong></div>
              <div><span style={{ color:'var(--muted)' }}>Firma:</span> <strong>{a.firma_adi || '—'}</strong></div>
              {a.fatura_no && <div><span style={{ color:'var(--muted)' }}>Fatura No:</span> <strong style={{ color:'var(--purple)' }}>#{a.fatura_no}</strong></div>}
            </div>
            {/* Ekspertiz özeti */}
            {ekspOzet && (
              <div style={{ fontSize:12, color:'var(--blue)', fontWeight:700 }}>
                💰 Fatura Bedeli: {ekspOzet.toplam_kalem} kalem
                {Number(ekspOzet.iscilik_toplam) > 0 && ` + ${Number(ekspOzet.iscilik_toplam).toLocaleString('tr-TR',{minimumFractionDigits:2})} ₺ işçilik`}
              </div>
            )}
          </div>
        </div>
        {/* Butonlar */}
        {muhSekme === 'bekliyor' && (
          <div style={{ display:'flex', gap:0, borderTop:'1px solid var(--border)', flexDirection:isMobile ? 'column' : 'row' }}>
            <button onClick={() => setIptalMod(a)} style={{
              flex:1, background:'var(--surface2)', color:'var(--muted)', border:'none', borderRight:'1px solid var(--border)',
              padding:'11px', cursor:'pointer', fontFamily:"'Barlow Condensed',sans-serif",
              fontSize:12, fontWeight:700, letterSpacing:1, textTransform:'uppercase',
            }}>❌ İptal</button>
            <button onClick={() => { setFatNoMod(a); setFatNoVal(''); }} style={{
              flex:2, background:'var(--purple)', color:'white', border:'none',
              padding:'11px', cursor:'pointer', fontFamily:"'Barlow Condensed',sans-serif",
              fontSize:12, fontWeight:800, letterSpacing:1, textTransform:'uppercase',
            }}>💵 Fatura Kes</button>
          </div>
        )}
        {muhSekme === 'kesildi' && (
          <div style={{ padding:'8px 20px', background:'#eafaf1', fontSize:12, color:'var(--green)', fontWeight:700, display:'flex', alignItems:'center', justifyContent:'space-between' }}>
            <span>✅ Fatura Kesildi — #{a.fatura_no}</span>
            <button onClick={() => { setFatGuncelleMod(a); setFatGuncelVal(a.fatura_no || ''); }} style={{
              background:'#1f7ae0', color:'white', border:'none', borderRadius:3,
              padding:'6px 10px', cursor:'pointer',
              fontFamily:"'Barlow Condensed',sans-serif", fontSize:11, fontWeight:700,
              letterSpacing:1, textTransform:'uppercase',
            }}>Fatura No Güncelle</button>
          </div>
        )}
        {muhSekme === 'iptal' && (
          <div style={{ padding:'8px 20px', background:'#fdecea', fontSize:12, color:'var(--accent)', fontWeight:700 }}>
            ❌ İptal Edildi
          </div>
        )}
      </div>
    );
  };

  if (!gor('muhasebe')) {
    return (
      <div style={{ display:'flex', alignItems:'center', justifyContent:'center', minHeight:'100vh',
        fontFamily:"'Barlow Condensed',sans-serif", fontSize:16, color:'var(--muted)' }}>
        Bu sayfayı görüntüleme yetkiniz yok.
      </div>
    );
  }

  return (
    <div style={{ fontFamily:"'Barlow',sans-serif", background:'var(--bg)', minHeight:'100vh' }}>

      {/* NAV */}
      <div style={{ background:'var(--ink)', position:'sticky', top:0, zIndex:200 }}>
        <div style={{ maxWidth:1040, margin:'0 auto', padding:isMobile ? '12px 16px' : '0 20px', display:'flex', alignItems:'center', minHeight:isMobile ? 'auto' : 50, gap:10, flexWrap:isMobile ? 'wrap' : 'nowrap' }}>
          <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:22, fontWeight:900, color:'white', letterSpacing:-1 }}>
            <Logo height={24} />
          </div>
          <span style={{ fontSize:11, fontWeight:700, letterSpacing:2, color:'rgba(255,255,255,.4)', textTransform:'uppercase', flex:isMobile ? '1 1 100%' : '0 1 auto' }}>Muhasebe</span>
          <div style={{ marginLeft:isMobile ? 0 : 'auto', display:'flex', gap:6, width:isMobile ? '100%' : 'auto' }}>
            <button onClick={onGeriDon} style={navBtn()}>‹ Ana Sayfa</button>
          </div>
        </div>
      </div>

      {/* SEKMELER */}
      <div style={{ background:'var(--ink)', borderBottom:'1px solid rgba(255,255,255,.1)' }}>
        <div style={{ maxWidth:1040, margin:'0 auto', padding:isMobile ? '0 8px' : '0 20px', display:'flex', gap:2, overflowX:'auto', scrollbarWidth:'none' }}>
          {[
            { id:'bekliyor', ad:'⏳ Fatura Bekliyor', sayi: faturaBekliyor.length },
            { id:'kesildi',  ad:'✅ Fatura Kesildi',  sayi: faturaKesildi.length  },
            { id:'iptal',    ad:'❌ İptal Edildi',     sayi: faturaIptal.length    },
          ].map(s => (
            <button key={s.id} onClick={() => setMuhSekme(s.id)} style={{
              background: muhSekme === s.id ? 'rgba(255,255,255,.12)' : 'transparent',
              border:'none', borderBottom: muhSekme === s.id ? '2px solid var(--accent)' : '2px solid transparent',
              color: muhSekme === s.id ? 'white' : 'rgba(255,255,255,.55)',
              padding:'12px 16px', cursor:'pointer',
              fontFamily:"'Barlow Condensed',sans-serif", fontSize:12, fontWeight:700,
              letterSpacing:1, textTransform:'uppercase', display:'flex', alignItems:'center', gap:6,
            }}>
              {s.ad}
              <span style={{ background:'rgba(255,255,255,.2)', borderRadius:10, padding:'1px 7px',
                fontSize:10 }}>{s.sayi}</span>
            </button>
          ))}
        </div>
      </div>

      <div style={{ maxWidth:1040, margin:'0 auto', padding:isMobile ? '20px 16px 32px' : '24px 20px' }}>

        {/* ARAMA */}
        <div style={{ marginBottom:16 }}>
          <input value={arama} onChange={e => setArama(e.target.value)}
            placeholder="Plaka veya firma ara..."
            style={{ fontFamily:"'Barlow',sans-serif", fontSize:13, border:'1px solid var(--border2)',
              borderRadius:3, padding:'9px 14px', width:'100%', maxWidth:isMobile ? '100%' : 360, outline:'none',
              background:'var(--surface)', boxSizing:'border-box' }} />
        </div>

        {yukleniyor ? (
          <div style={{ textAlign:'center', padding:60, color:'var(--muted)',
            fontFamily:"'Barlow Condensed',sans-serif", fontSize:14, fontWeight:700,
            letterSpacing:1, textTransform:'uppercase' }}>Yükleniyor...</div>
        ) : filtreli.length === 0 ? (
          <div style={{ textAlign:'center', padding:60, color:'var(--muted)',
            fontFamily:"'Barlow Condensed',sans-serif", fontSize:14, fontWeight:700,
            letterSpacing:1, textTransform:'uppercase' }}>Kayıt bulunamadı</div>
        ) : (
          <div style={{ display:'grid', gap:10 }}>
            {filtreli.map(a => <AracKart key={a.id} a={a} />)}
          </div>
        )}
      </div>

      {/* FATURA KES MODAL */}
      {fatNoMod && (
        <Modal baslik="Fatura Kes" renk="var(--purple)" onKapat={() => setFatNoMod(null)}>
          <div style={{ marginBottom:12, fontSize:13, color:'var(--ink2)' }}>
            <strong>{fatNoMod.plaka}</strong> · {fatNoMod.firma_adi}
          </div>
          <label style={{ fontSize:11, fontWeight:700, letterSpacing:1, textTransform:'uppercase',
            color:'var(--muted)', display:'block', marginBottom:6 }}>Fatura Numarası</label>
          <input value={fatNoVal} onChange={e => setFatNoVal(e.target.value)}
            placeholder="FAT-2025-00001"
            style={{ fontFamily:"'Barlow',sans-serif", fontSize:13, border:'1px solid var(--border2)',
              borderRadius:3, padding:'10px 12px', width:'100%', outline:'none',
              background:'var(--surface2)', boxSizing:'border-box', marginBottom:16 }} />
          <button onClick={faturaKes} style={{
            background:'var(--purple)', color:'white', border:'none', borderRadius:3,
            padding:'12px', width:'100%', cursor:'pointer',
            fontFamily:"'Barlow Condensed',sans-serif", fontSize:14, fontWeight:700,
            letterSpacing:1, textTransform:'uppercase',
          }}>Faturayı Kes</button>
        </Modal>
      )}

      {/* FATURA NO GÜNCELLE */}
      {fatGuncelleMod && (
        <Modal baslik="Fatura No Güncelle" renk="#1f7ae0" onKapat={() => setFatGuncelleMod(null)}>
          <div style={{ marginBottom:12, fontSize:13, color:'var(--ink2)' }}>
            <strong>{fatGuncelleMod.plaka}</strong> · {fatGuncelleMod.firma_adi}
          </div>
          <label style={{ fontSize:11, fontWeight:700, letterSpacing:1, textTransform:'uppercase',
            color:'var(--muted)', display:'block', marginBottom:6 }}>Yeni Fatura Numarası</label>
          <input value={fatGuncelVal} onChange={e => setFatGuncelVal(e.target.value)}
            placeholder="FAT-2025-00001"
            style={{ fontFamily:"'Barlow',sans-serif", fontSize:13, border:'1px solid var(--border2)',
              borderRadius:3, padding:'10px 12px', width:'100%', outline:'none',
              background:'var(--surface2)', boxSizing:'border-box', marginBottom:16 }} />
          <button onClick={faturaNoGuncelle} style={{
            background:'#1f7ae0', color:'white', border:'none', borderRadius:3,
            padding:'12px', width:'100%', cursor:'pointer',
            fontFamily:"'Barlow Condensed',sans-serif", fontSize:14, fontWeight:700,
            letterSpacing:1, textTransform:'uppercase',
          }}>Kaydet</button>
        </Modal>
      )}

      {/* İPTAL MODAL */}
      {iptalMod && (
        <Modal baslik="Fatura İptal" renk="var(--accent)" onKapat={() => setIptalMod(null)}>
          <p style={{ fontSize:13, color:'var(--ink2)', marginBottom:20 }}>
            <strong>{iptalMod.plaka}</strong> faturası iptal edilsin mi?
          </p>
          <div style={{ display:'flex', gap:10 }}>
            <button onClick={() => setIptalMod(null)} style={{
              flex:1, background:'var(--surface2)', color:'var(--muted)', border:'1px solid var(--border)',
              borderRadius:3, padding:'11px', cursor:'pointer',
              fontFamily:"'Barlow Condensed',sans-serif", fontSize:13, fontWeight:700,
            }}>Vazgeç</button>
            <button onClick={faturaIptalEt} style={{
              flex:1, background:'var(--accent)', color:'white', border:'none',
              borderRadius:3, padding:'11px', cursor:'pointer',
              fontFamily:"'Barlow Condensed',sans-serif", fontSize:13, fontWeight:700,
            }}>İptal Et</button>
          </div>
        </Modal>
      )}

      <Toast msg={toastMsg} />
    </div>
  );
}
